// extracted by mini-css-extract-plugin
module.exports = {"Landing":"Landing_Landing__2ibeb","Headline":"Landing_Headline__2dP_A","Btn":"Landing_Btn__3WR4u"};